import React from 'react';
import { StyledErrorPage, ListHeading, List } from './ErrorPages.styles';
import PlayText, { SIZE } from '../../../../ui-components/typography/PlayText/PlayText';
import { PlayLink } from '../../../../ui-components/PlayLink.styles';

const ErrorOnline = ({ pathname }: { pathname: string }) => (
    <StyledErrorPage>
        <PlayText size={SIZE.LARGE}>Vi ber om ursäkt, men just nu går det inte att visa innehållet.</PlayText>
        <ListHeading as="h2">Det kan bero på:</ListHeading>
        <List>
            <li>Att du har tappat din uppkoppling mot internet.</li>
            <li>Att vi har tillfälliga tekniska problem.</li>
        </List>
        <ListHeading>Vad du kan göra:</ListHeading>
        <List>
            <li>
                Testa att <PlayLink href={pathname}>ladda om sidan.</PlayLink>
            </li>
            <li>Återkom om en stund så är problemet förhoppningsvis löst.</li>
        </List>
        <PlayText size={SIZE.LARGE}>
            Om felet kvarstår under en längre tid,{' '}
            <PlayLink href="https://kontakt.svt.se">kontakta oss så ska vi försöka hjälpa dig.</PlayLink>
        </PlayText>
    </StyledErrorPage>
);

export default ErrorOnline;
